// UI copy only. User content and server-owned names stay in their original language.
import errorMessages from "./errorMessages.js";

export default {
  ...errorMessages,
  "提取后的正文需少于 390,000 个字符，请拆分文件后重新上传。": "The extracted text must contain fewer than 390,000 characters. Split the file and upload it again.",
  "请选择非空文件。": "Choose a non-empty file.",
  "文档正文至少需要 8 个字符。": "Document content must contain at least 8 characters.",
  "文档标题不能超过 64 个字符": "Document title must not exceed 64 characters",
  "文档类型不能超过 64 个字符": "Document type must not exceed 64 characters",
  "图片最大 10MB，其他文档最大 15MB": "Images up to 10MB; other documents up to 15MB",
  "图片大小不能超过 10MB": "Images must not exceed 10MB",
  "文档大小不能超过 15MB": "Documents must not exceed 15MB",
  "提取正文超出当前清洗工作流的长度限制，请拆分原文件后重新上传。": "The extracted text exceeds the current processing limit. Split the original file and upload it again.",
  "PDF 渲染失败，请联系管理员检查 PDF 渲染插件和服务。": "PDF rendering failed. Ask an administrator to check the PDF rendering plugin and service.",
  "DOC/PPT 转换失败，请联系管理员检查 LibreOffice 转换服务，或另存为 DOCX/PPTX 后重试。": "DOC/PPT conversion failed. Ask an administrator to check LibreOffice, or save the file as DOCX/PPTX and try again.",
  "文件预检失败，请重试；如持续失败，请联系管理员检查文件读取服务。": "File validation failed. Try again; if it persists, ask an administrator to check the file reading service.",
  "清洗服务拒绝了文件大小，请缩小文件，或联系管理员检查上传限制。": "The processing service rejected the file size. Use a smaller file or ask an administrator to check the upload limit.",
  "清洗服务请求失败，请稍后重试；如持续失败，请联系管理员。": "The processing service request failed. Try again later; if it persists, contact an administrator.",
  "清洗服务响应超时，请稍后重试；如持续失败，请联系管理员。": "The processing service timed out. Try again later; if it persists, contact an administrator.",
  "AI 助手": "AI assistant",
  "ALLFO 付费服务协议": "ALLFO Paid Services Agreement",
  "ALLFO 用户协议": "ALLFO User Agreement",
  "ALLFO 隐私政策": "ALLFO Privacy Policy",
  "Allfo 管理员": "Allfo administrator",
  "Allfo 用户工作台": "Allfo User Workspace",
  "个人设定": "Personal settings",
  "中": "Medium",
  "全部分类": "All categories",
  "全部格式": "All formats",
  "全部状态": "All statuses",
  "全部角色": "All roles",
  "全部设备类型": "All device types",
  "分段中": "Splitting",
  "删除后无法恢复，确定继续吗？": "This cannot be undone. Continue?",
  "删除失败": "Deletion failed",
  "删除文档": "Delete document",
  "删除聊天记录": "Delete chat record",
  "加载更早记录失败": "Could not load older records",
  "原文件暂不可下载": "The original file is not available for download yet",
  "可用": "Available",
  "向量化中": "Indexing",
  "四": "Thu",
  "在线设备": "Online devices",
  "处理中": "Processing",
  "处理失败": "Processing failed",
  "天团设备套系": "Tiantuan device series",
  "套系已解绑": "Series unlinked",
  "密码修改成功，请谨记新密码": "Password changed. Keep your new password safe.",
  "密码更新失败，请稍后重试": "Could not update password. Try again later.",
  "密码至少8位，并需包含大写、小写、数字、特殊字符中的任意3种": "Password must be at least 8 characters and include 3 of: uppercase, lowercase, numbers, and symbols.",
  "已停用": "Disabled",
  "已还原未保存的修改": "Unsaved changes discarded",
  "弱": "Weak",
  "强": "Strong",
  "当前产品": "Current product",
  "当前设备未绑定人格，请联系公司客服或您的服务人员协助配置。": "No persona is linked to this device. Contact support for setup help.",
  "我的账户": "My account",
  "排队中": "Queued",
  "文档处理失败": "Document processing failed",
  "文档已删除": "Document deleted",
  "新密码不能与原密码相同": "The new password must differ from the current one",
  "日常习惯": "Daily habits",
  "普通用户": "Standard user",
  "模型切换失败": "Could not switch models",
  "没有需要保存的更改": "No changes to save",
  "法律文件目前仅提供中文版本，请以中文原文为准。": "The legal documents are currently available in Chinese only. Please refer to the Chinese originals.",
  "清洗中": "Cleaning",
  "清理中": "Cleaning",
  "登录响应缺少凭证": "Sign-in response did not include a token",
  "登录失败，请检查账号信息": "Sign-in failed. Check your account information.",
  "目标偏好": "Goals and preferences",
  "目标设置需填写 5–140 字，当前": "Goal must be 5–140 characters; currently",
  "字": "characters",
  "套系": "Series",
  "模型已切换": "Model switched",
  "解绑套系后，套系内": "After unlinking this series, its",
  "台设备都会从当前账号移除，是否继续？": "devices will be removed from this account. Continue?",
  "暂不支持该文件格式。请上传": "Unsupported file format. Upload a document in",
  "格式的文档。": "format.",
  "文档大小不能超过": "Document size cannot exceed",
  "知识库已创建": "Knowledge base created",
  "离线设备": "Offline devices",
  "等待处理": "Waiting",
  "系统知识": "System knowledge",
  "聊天记录已删除": "Chat record deleted",
  "聊天记录已导出": "Chat history exported",
  "解析中": "Parsing",
  "解绑后设备会从当前账号移除，是否继续？": "The device will be removed from this account. Continue?",
  "解绑设备": "Unlink device",
  "设备已解绑": "Device unlinked",
  "设备端同步": "Synced from device",
  "设备编号已复制": "Device ID copied",
  "设备设置已保存": "Device settings saved",
  "请先阅读并同意用户协议与隐私政策": "Read and agree to the User Agreement and Privacy Policy first",
  "请完整填写密码信息": "Complete all password fields",
  "请求参数不正确，请检查后重试": "Invalid request. Check your input and try again.",
  "请求失败，请稍后重试": "Request failed. Try again later.",
  "请输入4位数字验证码": "Enter the 4-digit verification code",
  "请输入正确的手机号": "Enter a valid phone number",
  "请选择": "Select",
  "账户菜单": "account menu",
  "超级管理": "Administrator",
  "跟随产品默认": "Use product default",
  "验证码发送失败，请稍后重试": "Could not send the code. Try again later.",
  "验证码已发送": "Verification code sent",
  "（默认）": " (default)",
  "(5–140 字)": "(5–140 characters)",
  "(可选)": "(optional)",
  "/ 140 字": "/ 140 characters",
  "ALLFO 全局导航": "ALLFO main navigation",
  "《用户协议》": "User Agreement",
  "《隐私政策》": "Privacy Policy",
  "」设定明确的专属目标，系统将自动存入长期记忆存储区": "\"; it will be saved to long-term memory.",
  "上一年": "Previous year",
  "上个月": "Previous month",
  "上传后将自动构建语义向量索引，供所有绑定设备检索调用。": "A semantic index will be created after upload for all linked devices to search.",
  "上传文档": "Upload document",
  "上传知识库文档": "Upload knowledge document",
  "上传第一份文档，让设备开始认识你的内容。": "Upload your first document so your devices can use your content.",
  "下一年": "Next year",
  "下个月": "Next month",
  "下载原文件": "Download original",
  "与": " and ",
  "两次输入的新密码不一致": "The new passwords do not match",
  "个套系 · 共": " series · ",
  "为「": "Set a goal for \"",
  "产品：": "Product: ",
  "从一个清晰的空间开始": "Start with a clear space",
  "传道设备": "Chuandao device",
  "你的专属内容会在设备对话中被检索。": "Your content can be searched during device conversations.",
  "例如：个人核心目标与每日复盘指南": "For example: Personal goals and a daily review guide",
  "保存并存入长期记忆": "Save to long-term memory",
  "保存新密码": "Save new password",
  "保存设置": "Save settings",
  "保护您的 ALLFO 账号资产与设备数据安全": "Protect your ALLFO account and device data",
  "修改安全密码": "Change password",
  "修改密码": "Change password",
  "关闭": "Close",
  "分　　类：": "Category: ",
  "创建后才能上传文档，首次访问不会自动创建。": "Create a knowledge base before uploading documents. One is not created automatically.",
  "创建我的知识库": "Create my knowledge base",
  "创建知识库": "Create knowledge base",
  "初始默认值为空白，可直接在此键入 5–140 字的目标": "Start with an empty goal. Enter 5–140 characters here.",
  "删除": "Delete",
  "加载更早记录": "Load older records",
  "历史记录": "History",
  "取消": "Cancel",
  "可自定义称呼、回答风格与交互习惯。": "Customize how the device addresses you, responds, and interacts.",
  "台": " devices",
  "台设备": " devices",
  "台设备）": " devices)",
  "台）": " devices)",
  "固件版本": "Firmware version",
  "固件：": "Firmware: ",
  "国家或地区区号": "Country or region code",
  "在此输入您的目标，例如希望培养的作息习惯、阶段性学习成长计划或日常专注方向。设备将在日常交流中持续围绕此目标提供个性化互动。": "Enter a goal, such as a routine, learning plan, or area of focus. The device will use it to personalize daily conversations.",
  "在线": "Online",
  "在这里直接切换每个成员设备使用的模型；提示词请进入成员的“管理”页面修改。": "Choose a model for each device here. To edit prompts, open that device's management page.",
  "天团设备": "Tiantuan device",
  "套系内暂无设备": "No devices in this series",
  "套系设置加载失败": "Could not load series settings",
  "字数符合要求（": "Valid length (",
  "字）": " characters)",
  "字，至少需要 5 字": " characters; at least 5 required",
  "字，最多允许 140 字": " characters; maximum 140",
  "密码": "Password",
  "密码修改成功": "Password changed",
  "密码强度": "Password strength",
  "导出表格": "Export spreadsheet",
  "展开套系成员": "Expand series members",
  "已匹配": "Matched ",
  "已显示全部记录": "All records shown",
  "已连接": "Connected",
  "界面语言": "Language",
  "年": "-",
  "开始上传": "Start upload",
  "开始日期": "Start date",
  "开始更新": "Start update",
  "强度：": "Strength: ",
  "当前产品暂不支持在此页面管理设备设置": "This product's settings cannot be managed here yet",
  "当前产品暂无已发布模型策略，设备将继续使用产品默认模型。": "No model profiles are published for this product. Devices will continue using the product default.",
  "当前人格为普通聊天，不支持填写用户目标和用户提示词。": "This persona is for general chat and does not support a goal or user prompt.",
  "当前原密码": "Current password",
  "当前已输入": "Entered ",
  "当前设备": "Current device",
  "当前设备未绑定人格": "No persona linked to this device",
  "当前设备未绑定人格，请联系公司客服或服务人员协助配置。": "No persona is linked to this device. Contact support for help with setup.",
  "当日": "Today",
  "当月": "This month",
  "您的账号安全密码已更新，下次登录请使用新密码。": "Your password has been updated. Use the new password next time you sign in.",
  "成员": "Member",
  "成员设备": "Member devices",
  "我": "Me",
  "我希望在未来三个月养成规律运动和复盘的习惯。请每天主动关心我的进度，遇到困难时帮我把目标拆成轻松可执行的小步骤，并在我完成后给予具体鼓励。": "Over the next three months, I want to exercise regularly and review my progress. Check in daily, help me break obstacles into manageable steps, and encourage me when I make progress.",
  "我的知识库": "My knowledge base",
  "我的设备": "My devices",
  "房主": "Owner",
  "手机号": "Phone number",
  "手机号登录": "Phone sign-in",
  "按分类筛选": "Filter by category",
  "按文档格式筛选": "Filter by document format",
  "按角色筛选": "Filter by role",
  "按设备状态筛选": "Filter by device status",
  "按设备类型筛选": "Filter by device type",
  "搜索": "Search",
  "搜索聊天内容关键词": "Search chat messages",
  "支持": "Supports ",
  "收起套系成员": "Collapse series members",
  "文件大小：": "File size: ",
  "文件格式：": "File format: ",
  "文档处理进度": "Document processing progress",
  "文档标题": "Document title",
  "文档类型": "Document type",
  "新密码": "New password",
  "无法从服务端读取历史记录，请检查网络连接。": "Could not load history from the server. Check your connection.",
  "显示当前密码": "Show current password",
  "显示新密码": "Show new password",
  "显示确认密码": "Show confirmation password",
  "更新中...": "Updating...",
  "更新时间：": "Updated: ",
  "替换更新": "Replace and update",
  "替换更新知识库文档": "Replace knowledge document",
  "月": "-",
  "有未保存的修改": "Unsaved changes",
  "未分类": "Uncategorized",
  "未加入套系的": "Devices outside a series: ",
  "未命名设备": "Unnamed device",
  "未找到相关聊天记录": "No matching chat records",
  "未找到符合筛选条件的文档": "No matching documents",
  "未找到符合筛选条件的设备": "No matching devices",
  "未绑定人格": "No persona linked",
  "未选择文件": "No file selected",
  "条记录）": " records)",
  "查看套系成员，并为每台": "View series members and change the model for each ",
  "查看该设备的完整对话内容，默认按时间正序排列。": "View the full conversation for this device, oldest first by default.",
  "格式（单文件最大": " formats (maximum per file: ",
  "模型策略": "Model profile",
  "模型策略暂不可用": "Model profile unavailable",
  "选择该设备使用的模型策略，保存后立即生效。": "Choose the model profile for this device. It takes effect after you save.",
  "默认": "Default",
  "模糊搜索文档名称、内容摘要...": "Search document names and summaries...",
  "模糊搜索设备名称、编号、套系...": "Search device names, IDs, and series...",
  "欢迎使用": "Welcome to",
  "正在加载更早记录...": "Loading older records...",
  "正在导出...": "Exporting...",
  "正在更新筛选结果…": "Updating filtered results...",
  "清空日期": "Clear dates",
  "清空日期范围": "Clear date range",
  "点击日期开始选择范围": "Select a start date",
  "点击选择文件或拖拽至此处": "Choose a file or drag it here",
  "用户": "User",
  "用户提示词": "User prompt",
  "用户提示词最多允许 2000 字，当前": "User prompt may contain up to 2000 characters; currently",
  "登录": "Sign in",
  "登录 / 注册": "Sign in / Register",
  "登录即代表您已同意": "By signing in, you agree to the ",
  "登录方式": "Sign-in method",
  "目标保存后将实时持久存入设备的长期记忆区。设备在日常对话中将主动围绕该目标感知进度、给予针对性关怀与行动督促。": "The goal will be saved to the device's long-term memory. During daily conversations, the device can check your progress and offer relevant support.",
  "目标初始默认值为空白。可直接在此输入 5–140 字的目标。": "The goal is empty by default. Enter 5–140 characters here.",
  "目标设置": "Goal settings",
  "目标设置与用户提示词": "Goal and user prompt",
  "知识库筛选": "Knowledge base filters",
  "知识库还没有文档": "No documents in this knowledge base",
  "知识文档": "Knowledge documents",
  "确认新密码": "Confirm new password",
  "确认退出": "Confirm sign-out",
  "确认退出登录？": "Sign out?",
  "离线": "Offline",
  "称呼我指挥官；分析直击要害，少谈虚妄，多提务实良策。": "Call me Commander. Be direct and practical in your analysis.",
  "稍后在页面填写": "Fill in later",
  "筛选：": "Filter: ",
  "管理": "Manage",
  "管理套系": "Manage series",
  "篇文档": " documents",
  "结束日期": "End date",
  "聊天记录": "Chat history",
  "聊天记录 ·": "Chat history · ",
  "聊天记录加载失败": "Could not load chat history",
  "聊天记录筛选": "Chat history filters",
  "联系公司客服": "Contact support",
  "自定义称呼、回答风格与交互习惯": "Customize address, response style, and interaction habits",
  "获取验证码": "Get code",
  "解绑": "Unlink",
  "解绑套系": "Unlink series",
  "设备上线后自动同步": "Will sync when the device comes online",
  "设备产生交互后，聊天记录会在这里按时间线展示。": "Chat records will appear here after the device is used.",
  "设备切换模型。": " device.",
  "设备筛选": "Device filters",
  "设备编号：": "Device ID: ",
  "设备设置加载失败": "Could not load device settings",
  "设备详情": "Device details",
  "设备：": "Device: ",
  "设定设备的长期核心目标，AI 将结合上下文持续主动引导与辅助": "Set a long-term goal. AI will use the context to offer ongoing guidance and support.",
  "该设备暂无聊天记录": "No chat records for this device",
  "请再次输入新密码": "Enter the new password again",
  "请在 Allfo App 中完成设备绑定后回来查看。": "Link a device in the Allfo app, then return here to view it.",
  "请联系公司客服或服务人员协助绑定人格，完成后即可设置长期目标和交互偏好。": "Contact support to link a persona. You can then set a long-term goal and interaction preferences.",
  "请输入密码": "Enter your password",
  "请输入当前使用的密码": "Enter your current password",
  "请输入手机号": "Enter your phone number",
  "请输入新密码（至少8位）": "Enter a new password (at least 8 characters)",
  "请输入验证码": "Enter the verification code",
  "请选择或输入文档类型": "Select or enter a document type",
  "请选择结束日期": "Select an end date",
  "调整关键词或重置筛选条件后再试。": "Change the search terms or reset the filters and try again.",
  "调整角色或关键词筛选条件后再试。": "Change the role or keywords and try again.",
  "账号角色": "Account role",
  "账密登录": "Password sign-in",
  "输入目标内容（5–140 字）": "Enter a goal (5–140 characters)",
  "返回": "Back",
  "返回我的设备列表": "Back to my devices",
  "返回设备列表": "Back to devices",
  "还没有知识库": "No knowledge base yet",
  "还没有绑定设备": "No devices linked yet",
  "连接与管理您的智能硬件伴侣，随时掌控运行状态与交互记录。": "Connect and manage your smart devices, their status, and interaction history.",
  "退出当前账号后，您需要重新验证身份并登录以访问 ALLFO 设备工作台。": "After signing out, you will need to sign in again to access your ALLFO device workspace.",
  "退出登录": "Sign out",
  "选择日期范围": "Select date range",
  "选择模型策略": "Select model profile",
  "配置已与设备实时同步": "Settings synced with device",
  "配置该设备的个性化交互与云端设置": "Configure personalized interactions and cloud settings for this device",
  "配置长期记忆目标": "Set a long-term memory goal",
  "重新加载": "Reload",
  "重新选择": "Choose another file",
  "重置": "Reset",
  "重置所有筛选条件": "Reset all filters",
  "重置筛选": "Reset filters",
  "重置筛选条件": "Reset filters",
  "长期记忆持久化存储": "Persistent long-term memory",
  "隐藏当前密码": "Hide current password",
  "隐藏新密码": "Hide new password",
  "隐藏确认密码": "Hide confirmation password",
  "集中管理专属知识、提示词与项目文档，供智能设备随时调阅参考。": "Manage knowledge, prompts, and project documents for your devices to reference.",
  "验证码": "Verification code",
  "验证码登录时，如果手机号尚未注册，系统会自动创建账号。": "If this phone number is not registered, signing in with a code will create an account.",
  "默认按时间正序排列 · 完整内容展示": "Oldest first by default · Full messages shown",
  "（共": "(Total: ",
  "（独立设备 ·": "(Standalone devices · ",
};
